export default __webpack_public_path__ + "static/media/author.1970d199.PNG";